import axios from "axios";

const request = axios.create({
  baseURL: "/api",
  timeout: 10000
});

request.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const novelKey = localStorage.getItem("current_novel_key") || "default";
  // config.headers["X-Novel-Key"] = novelKey; // Remove this line as it causes issues with non-ASCII characters. query param is enough.
  config.params = config.params || {};
  if (!config.params.novel_key) {
    config.params.novel_key = novelKey;
  }
  return config;
});

request.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (window.location.hash !== "#/login") {
        window.location.hash = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default request;
